module.exports = __webpack_public_path__ + "static/pad.ed2e213c.png";